import { useState, useEffect, useCallback } from 'react'
import { db } from '@services/db.js'
import { buildModulosChecklist } from '@utils/buildModulosChecklist.js'
import type { ModuloStatus } from '@hooks/useModulos.js'
import type { TopicoStatus } from '@hooks/useModuloDetail.js'

export interface TopicoChecklistItem {
  id: string
  slug: string
  titulo: string
  ordem: number
  moduloId: string
  status: TopicoStatus
}

export interface ModuloChecklist {
  id: string
  slug: string
  titulo: string
  icone: string
  ordem: number
  pct: number
  concluidos: number
  total: number
  status: ModuloStatus
  topicos: TopicoChecklistItem[]
}

export function useChecklistGeral() {
  const [modulos, setModulos] = useState<ModuloChecklist[]>([])
  const [isLoading, setIsLoading] = useState(true)

  const load = useCallback(async () => {
    const progressoAll = await db.topicos_progresso.toArray()
    setModulos(buildModulosChecklist(progressoAll))
    setIsLoading(false)
  }, [])

  useEffect(() => {
    load()
  }, [load])

  return { modulos, isLoading, reload: load }
}
